import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { validationsList_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {configSuggestedArticles_template} from "../components/templates/configSuggestedArticles_template";

declare var ko: any;
declare var page: any;

export class config_suggested_articles extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected configSuggestedArticles: configSuggestedArticles_template;
    protected validationsList: validationsList_template;
    //protected _isLeavePageWarningNeeded: boolean = true;

    protected getModuleName(){
        return "config_suggested_articles";
    }

    buildContent() : Array<Element>{

        this.configSuggestedArticles = new configSuggestedArticles_template( "configSuggestedArticles", this.viewModel, this );
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Website Recommendation Config");

        return [ this.configSuggestedArticles.build()];
    }

    public fillPage() : void{

        this.getConfigSettings();
    }

    protected getConfigSettings(){

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/config/infinite-scroll/get/";
        let usrReq_params: Array<Array<string>> = [];

        this.loadingIn(this.configSuggestedArticles.builtTemplate)

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetConfigSettingsReturn;
        this.XHRHdl.execute();
    }

    protected onGetConfigSettingsReturn(req,obj){
        return function(){
            obj.manageResponse(req, obj, function() {
                let responseParsed = JSON.parse(req.request.response);

                if(responseParsed.infiniteScrollMinArticles){
                    obj.configSuggestedArticles.setInfiniteScrollMinArticles(responseParsed.infiniteScrollMinArticles);
                }

                if(responseParsed.infiniteScrollMaxArticles){
                    obj.configSuggestedArticles.setInfiniteScrollMaxArticles(responseParsed.infiniteScrollMaxArticles);
                }

                if(responseParsed.infiniteScrollRules){
                    let rules = obj.getRulesFormatted(responseParsed.infiniteScrollRules, responseParsed.infiniteScrollMinArticles);
                    obj.configSuggestedArticles.setInfiniteScrollRules(rules);
                }

                if(responseParsed.trendingMinArticles){
                    obj.configSuggestedArticles.setTrendingMinArticles(responseParsed.trendingMinArticles);
                }

                if(responseParsed.trendingMaxArticles){
                    obj.configSuggestedArticles.setTrendingMaxArticles(responseParsed.trendingMaxArticles);
                }

                if(responseParsed.trendingRules){
                    let rules = obj.getRulesFormatted(responseParsed.trendingRules, responseParsed.trendingMinArticles);
                    obj.configSuggestedArticles.setTrendingRules(rules);
                }

                if(responseParsed.fullList){
                    let rules = obj.getRulesFormatted(responseParsed.fullList, null);
                    obj.configSuggestedArticles.setFullListRules(rules);
                }

                if(responseParsed.threadMaxArticles){
                    obj.configSuggestedArticles.setThreadMaxArticles(responseParsed.threadMaxArticles);
                }

                if(responseParsed.threadMinArticles){
                    obj.configSuggestedArticles.setThreadMinArticles(responseParsed.threadMinArticles);
                }

                obj.loadingOut(obj.configSuggestedArticles.builtTemplate);
            })
        }
    }

    protected getRulesFormatted(rules, minArticles = 15) {
        let formattedRules = [];
    
        for (let i = 0; i < rules.length; i++) {
            let rule = rules[i];
    
            let formattedRule = "";
            let categorizationCondition = "";
            let publishCondition = "";
            let viewsCondition = "";
            let commentCondition = "";
            
            // Add the special rule description before the last rule
            if (i === rules.length - 1) {
                formattedRules.push({
                    position: rule.position,
                    description: `
                    Most recent articles from the homepage list of the same type if possible (amount equal to minimum article pool), if not, pull from the homepage list
                    `
                });
                i++;
            }

            if (rule.maxPublishDays) {
                publishCondition = "published in the last <strong style=\"font-size: 1.2rem;\">" + rule.maxPublishDays + "</strong> days ";
            } else {
                publishCondition = "<strong style=\"font-size: 1.2rem;\">" + minArticles + "</strong> most recent articles from homepage list to fill the minimum article pool ";
            }
    
            if (rule.isSameTag) {
                categorizationCondition = "Articles with the same <strong style=\"font-size: 1.2rem;\">primary tag</strong> ";
            }
    
            if (rule.isSameCat) {
                categorizationCondition = "Articles with the same <strong style=\"font-size: 1.2rem;\">primary category</strong> ";
            }
    
            if (rule.isSameNetworkCat) {
                categorizationCondition = "Articles with the same <strong style=\"font-size: 1.2rem;\">network category</strong> ";
            }
    
            if (rule.isTrending) {
                let hours = rule.maxViewTimeRange * 24 + " ";
    
                if (rule.minViews) {
                    viewsCondition = "and at least <strong style=\"font-size: 1.2rem;\">" + rule.minViews + "</strong> views in the past <strong style=\"font-size: 1.2rem;\">" + hours + "</strong> hours ";
                } else {
                    viewsCondition = "with the most views in the past <strong style=\"font-size: 1.2rem;\">" + hours + "</strong> hours ";
                }
            }
    
            if (rule.minComments && rule.maxCommentTimeRange) {
                let hours = rule.maxCommentTimeRange * 24 + " ";
                commentCondition = "at least <strong style=\"font-size: 1.2rem;\">" + rule.minComments + "</strong> comments in the past <strong style=\"font-size: 1.2rem;\">" + hours + "</strong> hours ";
            }
    
            formattedRule = categorizationCondition + "(" + publishCondition + viewsCondition + ")";
            if (!rule.maxPublishDays) {
                formattedRule = publishCondition + categorizationCondition + viewsCondition;
            }
            if (commentCondition) {
                formattedRule = `${formattedRule} <strong style="font-size: 1.2rem;">or</strong> ` + `(${commentCondition})`;
            }
    
            
    
            formattedRules.push({ position: i+1, description: formattedRule });
        }
    
        return formattedRules;
    }
    


    public triggerNotification(message: string): void {
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, message);
        this.getVnAppZone().showNotificationToModule();
    }

    public cancelForm() {
        page.redirect('/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/');
    }

}



// WEBPACK FOOTER //
// ./js/modules/config_suggested_articles.ts